import { useDispatch } from 'react-redux'
import { showAlert } from '../../redux/reducers/alertSlice'
import api from '../../../_metronic/helpers/api';
import { useNavigate } from 'react-router-dom';
import { stringify } from 'qs';

export default function useUtils() {
   const dispatch = useDispatch()  
   const navigate = useNavigate()

   const fetchCohort = async (limit, offset) => {
    const params = {
      limit,
      offset,
    };
    try {
      const response = await api.get(`/cohort?${stringify(params)}`);
      if (response.data.status) {
        return response.data.data;
      }
    } catch (error) {
      console.error(error);
    }
  };

  const submitCohort = async(values) =>{
    try {
      const payload = {
        ...values,
        startDate: values.startDate ? values.startDate.getTime() : null,
        endDate: values.endDate ? values.endDate.getTime() : null,
      };

      const response = await api.post(`/cohort`, payload);
      if (response?.data?.status) {
        dispatch(
          showAlert({
            message: "Cohort added",
            variant: "success",
          })
        );
        navigate("/cohortlist");
      } else {
        dispatch(
          showAlert({ message: response?.data?.message, variant: "danger" })
        );
      }
    } catch (error) {
      dispatch(
        showAlert({
          message: error?.response?.data?.message || "An error occurred",
          variant: "danger",
        })
      );
    }
  }

  const deleteCohort = async(id,limit, offset ) =>{
    try {
      const response = await api.delete(`/cohort/${id}`);
      if (response.data.status) {
        dispatch(
          showAlert({
            message: `Successfully Deleted`,
            variant: "success",
            timeout: "2000",
          })
        );
        return fetchCohort(limit, offset);
      }
    } catch (error) {
      dispatch(showAlert({ message: error.message, variant: "danger" }));
    }
  }

  const handleEdit = async(isActive, id, title) =>{
    try {
      const response = await api.patch(`/cohort/${id}`, {isActive});
      if (response.data.status==='success') {
        dispatch(
          showAlert({
            message: `${title} cohort activated`,
            variant: "success",
            timeout: "2000",
          })
        )
        return true
      }
    } catch (error) {
        dispatch(
            showAlert({
              message:error.message,
              variant: "danger",
              timeout: "2000",
            })
          )
       }
  }

   return {handleEdit, submitCohort, fetchCohort, deleteCohort}
}
